import React, { useState } from 'react';
import { IconButton, Menu, SxProps } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { ContextualMenuItem, ContextualMenuItemProps } from '../../atoms';

export type ContextualMenuProps = {
    items: Array<ContextualMenuItemProps>;
    buttonSx?: SxProps;
};

const ContextualMenu: React.FunctionComponent<ContextualMenuProps> = function (props) {
    const { items, buttonSx = {} } = props;
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleShowMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleHideMenu = () => {
        setAnchorEl(null);
    };

    if (!items.length) {
        return null;
    }

    return (
        <>
            <IconButton
                aria-label="more"
                aria-haspopup="true"
                onClick={handleShowMenu}
                sx={buttonSx}
            >
                <FaOptionIcon
                    icon={['fasl', 'ellipsis']}
                    sx={{ fontSize: '1rem' }}
                />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={anchorEl !== null}
                onClose={handleHideMenu}
            >
                {items.map((item) => (
                    <ContextualMenuItem
                        key={item.label}
                        {...item}
                        onClick={() => {
                            handleHideMenu();
                            item.onClick();
                        }}
                    />
                ))}
            </Menu>
        </>
    );
};

export default ContextualMenu;
